import {useMutation} from '@apollo/react-hooks';

import type {
    UpdateSetting as UpdateSettingMutation,
    UpdateSettingVariables as UpdateSettingMutationVariables,
} from 'nutshell-graphql-types';

import UPDATE_SETTING from './graphql/mutations/update-setting.graphql';
import GET_SETTING from './graphql/queries/get-setting.graphql';

export function useUpdateSetting(): (arg1: {
    settingName: string;
    value: any;
    isGlobal?: boolean;
    userId?: string;
}) => Promise<any> {
    const [updateSetting] = useMutation<UpdateSettingMutation, UpdateSettingMutationVariables>(
        UPDATE_SETTING
    );

    return (input: {settingName: string; value: any; isGlobal?: boolean; userId?: string}) => {
        return updateSetting({
            variables: {
                setting: {
                    name: input.settingName,
                    value: input.value,
                    isGlobal: input.isGlobal,
                    userId: input.userId,
                },
                // @ts-expect-error
                fetchPolicy: 'cache-and-network',
            },
            optimisticResponse: {
                // @ts-expect-error
                __typename: 'Mutation',
                updateSetting: {
                    __typename: 'UpdateSettingPayload',
                    setting: {
                        __typename: 'Setting',
                        id: input.settingName,
                        value: input.value,
                    },
                },
            },
            update: (proxy, mutationResults) => {
                let cacheResult;
                try {
                    cacheResult = proxy.readQuery({
                        query: GET_SETTING,
                        variables: {
                            settingName: input.settingName,
                            isGlobal: input.isGlobal,
                        },
                    });
                } catch {
                    cacheResult = null;
                }

                const newSetting =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.updateSetting &&
                    mutationResults.data.updateSetting.setting;

                if (cacheResult) {
                    proxy.writeQuery({
                        query: GET_SETTING,
                        variables: {settingName: input.settingName, isGlobal: input.isGlobal},
                        data: {setting: newSetting},
                    });
                }
            },
        });
    };
}
